import { resourcesCopy } from '@/copy/resources'
import { Field, Textarea } from '@/ui/Field/Field'
import type { FieldProps, Fields, ResourceFormDescriptor } from './shared'

/** Form-state key holding the whole `data` blob as pretty-printed JSON. */
const JSON_KEY = '__json'

/**
 * Generic editor for kinds without a registered form: the entire `data` blob
 * as editable JSON, so every existing resource stays viewable/editable even
 * if its kind has no hand-written descriptor (yet).
 */
// eslint-disable-next-line react-refresh/only-export-components -- local component; the descriptor below is this file's only export
function FallbackFields({ fields, set }: FieldProps) {
  return (
    <Field id="res-data" label={resourcesCopy.forms.fallback.data}>
      <Textarea
        id="res-data"
        value={fields[JSON_KEY] ?? ''}
        onChange={(e) => set(JSON_KEY, e.target.value)}
        rows={16}
        spellCheck={false}
        mono
      />
    </Field>
  )
}

export const fallbackForm: ResourceFormDescriptor = {
  Fields: FallbackFields,
  fromResource: (d: unknown) => ({
    [JSON_KEY]: JSON.stringify(d ?? {}, null, 2),
  }),
  toBody: (f: Fields) => {
    const text = (f[JSON_KEY] ?? '').trim()
    if (!text) return {}
    try {
      return JSON.parse(text)
    } catch (e) {
      throw new Error(
        resourcesCopy.forms.fallback.invalidJson((e as Error).message),
        { cause: e },
      )
    }
  },
}
